import type {
  PersonalInfo,
  Article,
  Stat,
  PortfolioItem,
  SidebarHighlight,
  Testimonial,
  ContactMethod,
  NavItem
} from '@/types';
import { HomeIcon, FileIcon, BarChartIcon, GridIcon, MailIcon } from '@/components/Navigation/NavIcons';

export const personalInfo: PersonalInfo = {
  firstName: "NICKLAS",
  lastName: "NORDSTRÖM",
  portraitSrc: "/images/Nicklas.webp",
  portraitAlt: "Nicklas Nordström - Journalist och Digital Storyteller",
  email: "nicklas@nordstrom.se",
  phone: "+46 70 123 45 67",
  social: "@nicklasnordstrom"
};

export const navItems: NavItem[] = [
  { id: "cover", label: "TOPP", href: "#cover", iconComponent: HomeIcon },
  { id: "feature", label: "INTRO", href: "#feature", iconComponent: FileIcon },
  { id: "stats", label: "STATISTIK", href: "#stats", iconComponent: BarChartIcon },
  { id: "portfolio", label: "PORTFOLIO", href: "#portfolio", iconComponent: GridIcon },
  { id: "contact", label: "KONTAKT", href: "#contact", iconComponent: MailIcon }
];

export const issueInfo = "JOURNALIST • SKRIBENT • COPYRIGHT";

export const coverStory = "Berättelser som formar framtiden";

export const mainArticle: Article = {
  title: "Journalistik i den digitala eran",
  subtitle: "Hur berättande utvecklas i takt med teknologin",
  byline: "Av Nicklas Nordström",
  content: [
    "I en tid där informationsflödet aldrig varit större och konkurrensen om läsarnas uppmärksamhet hårdare än någonsin, krävs det mer än bara fakta för att skapa genomslagskraft. Modern journalistik handlar om att kombinera traditionell grävande metodik med innovativa berättartekniker.",
    "Sedan 1995 har jag arbetat som journalist och bevittnat medielandskapets fundamentala transformation. Från tryckta tidningar till digitala plattformar, från linjära berättelser till interaktiva upplevelser. Min resa har tagit mig från reporter på Helsingborgs Dagblad, Sydsvenskan och Arbetet till dagens frilansarbete för publikationer som Arkitekten, Dagens ETC, Landskap, Magasin K och Dagens Industri.",
    "Den moderna journalisten måste vara en digital polymat - skicklig på att hantera både ord och multimedia, data och narrativ, fakta och känslor. Med specialisering inom miljö och hållbarhet kombinerar jag djup samhällsanalys med berättande kraft. Jag har bevakat politik och samhällsutveckling på alla nivåer - från lokal till nationell - och skrivit allt från nyheter och reportage till krönikor.",
    "Men trots all teknisk utveckling förblir grundpelarna oförändrade: noggrann research, kritiskt tänkande och förmågan att berätta historier som berör människor. Med utbildning från JMG i Göteborg och studier i litteraturvetenskap, statsvetenskap och miljökunskap har jag byggt en bred kunskapsbas som berikar varje berättelse. Teknologin är vårt verktyg, men mänskliga berättelser är vårt hjärta."
  ]
};

export const sidebarHighlights: SidebarHighlight[] = [
  {
    title: "Miljö & Hållbarhet",
    description: "Specialisering inom klimat och samhällsutveckling"
  },
  {
    title: "Bred Erfarenhet",
    description: "Från dagstidningar till fackpress och magasin"
  },
  {
    title: "Mångsidig Journalist",
    description: "Nyheter, reportage, krönikor och analys"
  }
];

export const testimonial: Testimonial = {
  quote: "Nicklas representerar den nya generationen journalister som förstår att teknologi och berättande inte är motsatser, utan perfekta partners.",
  author: "Prof. Maria Karlsson",
  title: "JMK"
};

export const quoteText = "En bra berättelse förändrar inte bara vad läsaren vet, utan också vad läsaren känner och tänker.";

export const stats: Stat[] = [
  { number: "30+", label: "År av erfarenhet" },
  { number: "1995", label: "Började som journalist" },
  { number: "10+", label: "Publikationer" },
  { number: "JMG", label: "Journalistutbildning" }
];

export const portfolioItems: PortfolioItem[] = [
  {
    id: "1",
    title: "Dagens Industri",
    publication: "Dagens Industri",
    year: 2024,
    imageSrc: "/images/dagensindustri.png"
  },
  {
    id: "2",
    title: "Klimatkrisen i Arktis",
    publication: "Landskap",
    year: 2023,
    imageSrc: "/images/landskap.png"
  },
  {
    id: "3",
    title: "AI:s etiska dilemman",
    publication: "Forskning.se",
    year: 2023,
    imageSrc: "/images/forskning.se.png"
  },
  {
    id: "4",
    title: "Startup-ekosystemet",
    publication: "Dagens ETC",
    year: 2022,
    imageSrc: "/images/dagensetc.png"
  },
  {
    id: "5",
    title: "Framtidens arbete",
    publication: "Chef i fokus",
    year: 2022,
    imageSrc: "/images/chefenifokus.png"
  },
  {
    id: "6",
    title: "Digital demokrati",
    publication: "Magasin K",
    year: 2021,
    imageSrc: "/images/magasinK.png"
  }
];

export const contactMethods: ContactMethod[] = [
  {
    title: "Epost",
    value: "kontakt@nicklasnordstrom.se"
  },
  {
    title: "Telefon",
    value: "+46 70 XXX XX XX"
  },
  {
    title: "Nätverk",
    value: "blendajournalistik.se/nicklas-nordstrom"
  }
];
